export default __webpack_public_path__ + "451e167bbe5e7436fc95560d28289d88.svg";